// Common countries with Amazon presence (ISO 3166-1 alpha-2)
export const COUNTRIES = [
  { code: 'US', name: 'United States', currency: 'USD', flag: '🇺🇸', amazon: 'amazon.com' },
  { code: 'GB', name: 'United Kingdom', currency: 'GBP', flag: '🇬🇧', amazon: 'amazon.co.uk' },
  { code: 'CA', name: 'Canada', currency: 'CAD', flag: '🇨🇦', amazon: 'amazon.ca' },
  { code: 'DE', name: 'Germany', currency: 'EUR', flag: '🇩🇪', amazon: 'amazon.de' },
  { code: 'FR', name: 'France', currency: 'EUR', flag: '🇫🇷', amazon: 'amazon.fr' },
  { code: 'IT', name: 'Italy', currency: 'EUR', flag: '🇮🇹', amazon: 'amazon.it' },
  { code: 'ES', name: 'Spain', currency: 'EUR', flag: '🇪🇸', amazon: 'amazon.es' },
  { code: 'JP', name: 'Japan', currency: 'JPY', flag: '🇯🇵', amazon: 'amazon.co.jp' },
  { code: 'IN', name: 'India', currency: 'INR', flag: '🇮🇳', amazon: 'amazon.in' },
  { code: 'AU', name: 'Australia', currency: 'AUD', flag: '🇦🇺', amazon: 'amazon.com.au' },
  { code: 'BR', name: 'Brazil', currency: 'BRL', flag: '🇧🇷', amazon: 'amazon.com.br' },
  { code: 'MX', name: 'Mexico', currency: 'MXN', flag: '🇲🇽', amazon: 'amazon.com.mx' },
  { code: 'IE', name: 'Ireland', currency: 'EUR', flag: '🇮🇪', amazon: 'amazon.co.uk' },
  { code: 'NL', name: 'Netherlands', currency: 'EUR', flag: '🇳🇱', amazon: 'amazon.nl' },
  { code: 'SE', name: 'Sweden', currency: 'SEK', flag: '🇸🇪', amazon: 'amazon.se' },
  { code: 'PL', name: 'Poland', currency: 'PLN', flag: '🇵🇱', amazon: 'amazon.pl' },
  { code: 'BE', name: 'Belgium', currency: 'EUR', flag: '🇧🇪', amazon: 'amazon.com.be' },
  { code: 'SG', name: 'Singapore', currency: 'SGD', flag: '🇸🇬', amazon: 'amazon.sg' },
  { code: 'AE', name: 'United Arab Emirates', currency: 'AED', flag: '🇦🇪', amazon: 'amazon.ae' },
  { code: 'SA', name: 'Saudi Arabia', currency: 'SAR', flag: '🇸🇦', amazon: 'amazon.sa' },
];

// Supported languages - must match LanguageSelector.tsx (ISO 639-1)
export const LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'pt', name: 'Português' },
  { code: 'ja', name: '日本語' },
  { code: 'zh', name: '中文' },
  { code: 'pl', name: 'Polski' },
];

// Detect country and language from browser
export function detectLocale() {
  const browserLocale = navigator.language || 'en-US';
  const [detectedLanguage, detectedCountry] = browserLocale.split('-');
  
  return {
    country: (detectedCountry || 'US').toUpperCase(),
    language: (detectedLanguage || 'en').toLowerCase()
  };
}

interface CountryLanguageSelectorProps {
  nationality: string;
  language: string;
  onNationalityChange: (code: string) => void;
  onLanguageChange: (code: string) => void;
  showLabels?: boolean;
}

export function CountryLanguageSelector({
  nationality,
  language,
  onNationalityChange,
  onLanguageChange,
  showLabels = true
}: CountryLanguageSelectorProps) {
  // Removed unused state and filtering - component simplified

  return (
    <div className="country-language-selector">
      <div className="form-group">
        {showLabels && <label htmlFor="nationality">Country / Nationality</label>}
        <select
          id="nationality"
          value={nationality}
          onChange={(e) => onNationalityChange(e.target.value)}
          required
        >
          <option value="">Select your country...</option>
          {COUNTRIES.map(country => (
            <option key={country.code} value={country.code}>
              {country.flag} {country.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        {showLabels && <label htmlFor="language">Preferred Language</label>}
        <select
          id="language"
          value={language}
          onChange={(e) => onLanguageChange(e.target.value)}
          required
        >
          <option value="">Select language...</option>
          {LANGUAGES.map(lang => (
            <option key={lang.code} value={lang.code}>
              {lang.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
